(function () {
  // Delegates to skg-money.js so these figures match the Liquid `money` filter;
  // the inline fallback keeps prices readable if that asset fails to load.
  function formatMAD(cents) {
    if (window.SKGMoney) return window.SKGMoney.format(cents);
    var dh = (Number(cents || 0) / 100).toFixed(2);
    return dh.replace(/\.00$/, "") + " dh";
  }

  function uuid() {
    if (crypto && crypto.randomUUID) return crypto.randomUUID();
    return "id-" + Date.now() + "-" + Math.random().toString(16).slice(2);
  }

  function num(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  /** Matches the " — Default Title" trimming offer-option.liquid does in Liquid. */
  function cleanTitle(value) {
    return String(value == null ? "" : value)
      .replace(/\s*[—-]\s*Default Title$/, "")
      .trim();
  }

  /**
   * Pure pricing maths, no DOM. Builds the summary lines from the same loop
   * that sums the catalog, so the itemised list can never disagree with the
   * total. Mirrors the offer rules in apps/skg-commerce/src/lib/pricing.
   */
  function computeBreakdown(state) {
    var s = state || {};
    var sel = s.offer || {};
    var companion = s.companion || {};
    var unit = num(s.unitCents);
    var mixPercent = num(s.mixPercent);
    var companionPrice =
      sel.selection === "single" && companion.variantId ? num(companion.price) : 0;

    var lines = [];
    var catalog = 0;
    var offerDiscount = 0;
    var offerPercent = 0;

    if (sel.selection === "offer" && sel.items && sel.items.length) {
      sel.items.forEach(function (item) {
        var isGift = Boolean(item.isGift);
        var lineQty = num(item.quantity) || 1;
        if (sel.type === "quantity_breaks") lineQty = num(sel.qty) || 1;
        var lineCents = isGift ? 0 : num(item.unitPriceCents) * lineQty;
        lines.push({
          title: cleanTitle(item.title) || "Produit",
          quantity: lineQty,
          lineCents: lineCents,
          isGift: isGift,
        });
        if (!isGift) catalog += lineCents;
      });

      if (sel.type === "quantity_breaks") {
        if (num(sel.tierFixed) > 0) {
          offerDiscount = Math.max(0, catalog - num(sel.tierFixed));
        } else if (num(sel.tierPercent) > 0) {
          offerPercent = num(sel.tierPercent);
          offerDiscount = Math.round(catalog * (offerPercent / 100));
        } else if (num(sel.percent) > 0) {
          offerPercent = num(sel.percent);
          offerDiscount = Math.round(catalog * (offerPercent / 100));
        }
      } else if (sel.mode === "fixed_bundle_price") {
        offerDiscount = Math.max(0, catalog - num(sel.cents));
      } else if (sel.mode === "percent_off") {
        offerPercent = num(sel.percent);
        offerDiscount = Math.round(catalog * (offerPercent / 100));
      } else if (sel.mode === "fixed_off") {
        // Clamped: an over-large fixed_off must not read as more than the cart.
        offerDiscount = Math.min(Math.max(0, num(sel.cents)), catalog);
      }
    } else {
      var qty = sel.selection === "single" ? num(sel.qty) || 1 : 1;
      var mainCents = unit * qty;
      lines.push({
        title: cleanTitle(s.productTitle) || "Produit",
        quantity: qty,
        lineCents: mainCents,
        isGift: false,
      });
      catalog += mainCents;

      if (sel.selection === "single" && companion.variantId) {
        lines.push({
          title: cleanTitle(companion.title) || "Produit",
          quantity: 1,
          lineCents: companionPrice,
          isGift: false,
        });
        catalog += companionPrice;
      }

      if (companion.variantId && mixPercent > 0) {
        offerPercent = mixPercent;
        offerDiscount = Math.round(Math.min(unit, companionPrice) * (mixPercent / 100));
      }
    }

    var promoDiscount = Math.max(0, num(s.promoDiscountCents));
    var discount = Math.min(offerDiscount + promoDiscount, catalog);
    var shipping = 0;
    var total = Math.max(0, catalog - discount + shipping);

    return {
      lines: lines,
      catalog: catalog,
      offerDiscount: offerDiscount,
      offerPercent: offerPercent,
      promoDiscount: promoDiscount,
      discount: discount,
      shipping: shipping,
      total: total,
    };
  }

  // Exposed for the vitest harness in src/lib/cod-pricing.browser.test.ts.
  window.SKGCodPricing = {
    computeBreakdown: computeBreakdown,
    cleanTitle: cleanTitle,
    formatMAD: formatMAD,
  };

  function initRoot(root) {
    if (!root || root.dataset.bound === "1") return;
    root.dataset.bound = "1";

    var form = root.querySelector("[data-skg-cod-form]");
    var note = root.querySelector("[data-note]");
    var btn = root.querySelector("[data-submit]");
    var promoInput = root.querySelector("[data-promo-input]");
    var promoMsg = root.querySelector("[data-promo-msg]");
    var promoBtn = root.querySelector("[data-promo-apply]");
    var cityInput = root.querySelector("[data-city]");
    var lineHost = root.querySelector("[data-line-items]");
    var discountLabelEl = root.querySelector("[data-discount-label]");
    var discountLabelPlain = discountLabelEl
      ? discountLabelEl.getAttribute("data-label-plain") ||
        discountLabelEl.textContent.trim()
      : "";
    // Only usable if Liquid actually substituted the placeholder; otherwise the
    // plain label is shown rather than a literal "{{ percent }}".
    var discountLabelPercent = discountLabelEl
      ? discountLabelEl.getAttribute("data-label-percent") || ""
      : "";
    if (discountLabelPercent.indexOf("__PCT__") < 0) discountLabelPercent = "";
    var proxyBase = root.dataset.proxyBase || "/apps/skg";
    var idempotencyKey = uuid();
    var promoState = null;
    var turnstileToken = "";
    var turnstileWidgetId = null;
    var confirmingEl = root.querySelector("[data-confirming]");
    var confirmingStatus = root.querySelector("[data-confirming-status]");
    var confirmingTimer = null;
    var CONFIRMING_LINES = [
      "Confirmation de votre commande…",
      "Vérification de votre numéro…",
      "Préparation de votre commande…",
    ];

    function showConfirming() {
      if (!confirmingEl) return;
      var lineIndex = 0;
      if (confirmingStatus) {
        confirmingStatus.classList.remove("is-fading");
        confirmingStatus.textContent = CONFIRMING_LINES[0];
      }
      confirmingEl.hidden = false;
      confirmingEl.setAttribute("aria-hidden", "false");
      confirmingEl.setAttribute("aria-busy", "true");
      document.body.classList.add("skg-cod-confirming-open");

      if (confirmingTimer) clearInterval(confirmingTimer);
      confirmingTimer = setInterval(function () {
        if (!confirmingStatus) return;
        lineIndex = (lineIndex + 1) % CONFIRMING_LINES.length;
        confirmingStatus.classList.add("is-fading");
        setTimeout(function () {
          confirmingStatus.textContent = CONFIRMING_LINES[lineIndex];
          confirmingStatus.classList.remove("is-fading");
        }, 220);
      }, 800);
    }

    function hideConfirming() {
      if (confirmingTimer) {
        clearInterval(confirmingTimer);
        confirmingTimer = null;
      }
      if (!confirmingEl) return;
      confirmingEl.hidden = true;
      confirmingEl.setAttribute("aria-hidden", "true");
      confirmingEl.setAttribute("aria-busy", "false");
      document.body.classList.remove("skg-cod-confirming-open");
    }

    function selectedQty() {
      var checked = root.querySelector("[data-selected-qty]:checked");
      if (checked) return parseInt(checked.value, 10) || 1;
      var hidden = root.querySelector("[data-selected-qty-hidden]");
      return hidden ? parseInt(hidden.value, 10) || 1 : 1;
    }

    function companionSelection() {
      var checked = root.querySelector("[data-companion-choice]:checked");
      if (!checked || !checked.value) return { variantId: "", price: 0, title: "" };
      var card = checked.closest("[data-companion-card]");
      var nameEl = card ? card.querySelector(".skg-cod-v2__mix-name") : null;
      var title = nameEl ? nameEl.textContent.trim() : "";
      var sel = card ? card.querySelector("[data-companion-variant-select]") : null;
      if (sel && sel.value) {
        var opt = sel.selectedOptions && sel.selectedOptions[0];
        return {
          variantId: sel.value,
          price: parseInt((opt && opt.getAttribute("data-price")) || "0", 10) || 0,
          title: title,
        };
      }
      return {
        variantId: checked.value,
        price: parseInt(checked.getAttribute("data-companion-price") || "0", 10) || 0,
        title: title,
      };
    }

    function activeOfferId(companionId) {
      if (companionId && root.dataset.mixOfferId) return root.dataset.mixOfferId;
      return root.dataset.offerId || undefined;
    }

    /**
     * Maps the theme's root dataset onto the state shape computeBreakdown()
     * expects. The theme carries a single offer on the root element rather than
     * the extension's per-offer radios, so only this adapter differs.
     */
    function pricingState() {
      var companion = companionSelection();
      var items = [];
      try {
        var parsed = JSON.parse(root.dataset.offerItems || "null");
        if (Array.isArray(parsed)) items = parsed;
      } catch (err) {
        items = [];
      }
      // Long-standing theme rule: picking a companion replaces pack pricing
      // with the landing product plus that companion.
      var useOffer = Boolean(root.dataset.offerId) && items.length > 0 && !companion.variantId;

      return {
        unitCents: root.dataset.unitCents,
        mixPercent: root.dataset.mixPercent,
        productTitle: productTitle(),
        companion: companion,
        promoDiscountCents:
          promoState && promoState.promo_discount_cents
            ? promoState.promo_discount_cents
            : 0,
        offer: {
          selection: useOffer ? "offer" : "single",
          offerId: root.dataset.offerId || "",
          qty: selectedQty(),
          mode: root.dataset.offerPricingMode || "",
          percent: root.dataset.offerPricingPercent,
          cents: root.dataset.offerPricingCents,
          items: useOffer ? items : [],
          type: root.dataset.offerType || "",
          // The theme carries no per-tier pricing, so tiers fall through to the
          // offer-level percentage, as they always have here.
          tierPercent: 0,
          tierFixed: 0,
        },
      };
    }

    /** Paints one row per line. Returns true when the list replaces the subtotal. */
    function renderLines(lines) {
      if (!lineHost) return false;
      var freeLabel = lineHost.getAttribute("data-free-label") || "Offert";
      lineHost.textContent = "";
      lines.forEach(function (line) {
        var row = document.createElement("div");
        row.className = "skg-cod-v2__row skg-cod-v2__line";
        if (line.isGift) row.classList.add("skg-cod-v2__line--gift");

        var name = document.createElement("span");
        name.className = "skg-cod-v2__line-name";
        name.textContent = line.title;
        if (line.quantity > 1) {
          var qty = document.createElement("span");
          qty.className = "skg-cod-v2__line-qty";
          qty.textContent = "×" + line.quantity;
          name.appendChild(qty);
        }

        var price = document.createElement("span");
        price.className = "skg-cod-v2__line-price";
        price.textContent = line.isGift ? freeLabel : formatMAD(line.lineCents);

        row.appendChild(name);
        row.appendChild(price);
        lineHost.appendChild(row);
      });
      return lines.length > 0;
    }

    function estimateTotals() {
      var breakdown = computeBreakdown(pricingState());
      var listed = renderLines(breakdown.lines);

      var subRow = root.querySelector("[data-subtotal-row]");
      var subEl = root.querySelector("[data-subtotal]");
      var discEl = root.querySelector("[data-discount]");
      var discRow = root.querySelector("[data-discount-row]");
      var shipEl = root.querySelector("[data-shipping]");
      var totalEl = root.querySelector("[data-total]");

      if (subEl) subEl.textContent = formatMAD(breakdown.catalog);
      if (subRow) subRow.hidden = listed;
      if (discRow && discEl) {
        if (breakdown.discount > 0) {
          discRow.hidden = false;
          discEl.textContent = "-" + formatMAD(breakdown.discount);
        } else {
          discRow.hidden = true;
        }
      }
      if (discountLabelEl) {
        // A promo stacked on top makes the offer percentage no longer describe
        // the whole row, so fall back to the plain label.
        var showPercent =
          breakdown.offerPercent > 0 &&
          breakdown.promoDiscount === 0 &&
          discountLabelPercent;
        discountLabelEl.textContent = showPercent
          ? discountLabelPercent.replace("__PCT__", String(breakdown.offerPercent))
          : discountLabelPlain;
      }
      if (shipEl) {
        shipEl.textContent =
          breakdown.shipping > 0 ? formatMAD(breakdown.shipping) : "Gratuit";
      }
      if (totalEl) totalEl.textContent = formatMAD(breakdown.total);

      return breakdown.total;
    }

    function productTitle() {
      var el = root.querySelector(".skg-cod-v2__product-title");
      return el ? el.textContent.trim() : "";
    }

    function mountTurnstile() {
      var mount = root.querySelector("[data-turnstile]");
      var sitekey = root.dataset.turnstileSitekey;
      if (!mount || !sitekey) return;
      var tryMount = function () {
        if (!window.turnstile) {
          setTimeout(tryMount, 200);
          return;
        }
        turnstileWidgetId = window.turnstile.render(mount, {
          sitekey: sitekey,
          callback: function (token) {
            turnstileToken = token;
          },
          "expired-callback": function () {
            turnstileToken = "";
          },
        });
      };
      tryMount();
    }

    async function applyPromo() {
      promoMsg.textContent = "Vérification…";
      try {
        var res = await fetch(proxyBase + "/promo/validate", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            promo_code: promoInput.value || "",
            offer_id: activeOfferId(companionSelection().variantId),
            selected_qty: selectedQty(),
            phone: form.phone.value,
            city: form.city.value,
            main_variant_id: root.dataset.variantGid || undefined,
            companion_variant_id: companionSelection().variantId || undefined,
          }),
        });
        var data = await res.json();
        if (!data.ok) {
          promoState = null;
          promoMsg.textContent = data.error || "Code invalide";
          promoMsg.style.color = "#b91c1c";
        } else {
          promoState = data;
          promoMsg.textContent = data.message || "Code appliqué";
          promoMsg.style.color = "#166534";
        }
        estimateTotals();
      } catch (err) {
        promoMsg.textContent = "Erreur réseau";
        promoMsg.style.color = "#b91c1c";
      }
    }

    root.querySelectorAll("[data-selected-qty]").forEach(function (el) {
      el.addEventListener("change", estimateTotals);
    });
    root.querySelectorAll("[data-companion-choice]").forEach(function (el) {
      el.addEventListener("change", function () {
        estimateTotals();
        if (promoInput && promoInput.value.trim()) applyPromo();
      });
    });
    root.querySelectorAll("[data-companion-variant-select]").forEach(function (el) {
      el.addEventListener("change", function () {
        var card = el.closest("[data-companion-card]");
        var radio = card ? card.querySelector("[data-companion-choice]") : null;
        if (radio) {
          radio.value = el.value;
          var opt = el.selectedOptions && el.selectedOptions[0];
          radio.setAttribute(
            "data-companion-price",
            (opt && opt.getAttribute("data-price")) || "0",
          );
          radio.checked = true;
        }
        estimateTotals();
        if (promoInput && promoInput.value.trim()) applyPromo();
      });
    });
    if (cityInput) cityInput.addEventListener("input", estimateTotals);
    if (promoBtn) promoBtn.addEventListener("click", applyPromo);
    if (promoInput) {
      var t;
      promoInput.addEventListener("input", function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (promoInput.value.trim()) applyPromo();
        }, 500);
      });
    }

    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      note.textContent = "";
      btn.disabled = true;
      showConfirming();

      var honeypot = root.querySelector("[data-honeypot]");
      var companion = companionSelection();
      var payload = {
        idempotency_key: idempotencyKey,
        offer_id: activeOfferId(companion.variantId),
        selected_qty: selectedQty(),
        promo_code: (promoInput && promoInput.value) || undefined,
        name: form.name.value,
        phone: form.phone.value,
        city: form.city.value,
        address: form.address.value,
        turnstile_token: turnstileToken || "dev-bypass",
        honeypot: honeypot ? honeypot.value : "",
        main_variant_id: root.dataset.variantGid || undefined,
        companion_variant_id: companion.variantId || undefined,
      };

      var attr =
        window.SKGAttribution && typeof window.SKGAttribution.forSubmit === "function"
          ? window.SKGAttribution.forSubmit()
          : null;
      if (attr) {
        payload.source_url = attr.source_url;
        payload.page_url = attr.page_url;
        payload.referrer = attr.referrer;
        payload.utm = attr.utm;
        payload.ad_source = attr.ad_source;
      } else {
        var params = new URLSearchParams(location.search);
        var utmFallback = {};
        ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid", "ttclid", "msclkid"].forEach(
          function (key) {
            var val = params.get(key);
            if (!val) return;
            var short = key.indexOf("utm_") === 0 ? key.slice(4) : key;
            utmFallback[short] = val;
          },
        );
        payload.source_url = window.location.href;
        payload.page_url = window.location.href;
        payload.referrer = document.referrer || "";
        payload.utm = utmFallback;
        // No ad_source: the Worker derives it with the same rules plus the referrer fallback.
      }

      if (!payload.offer_id && root.dataset.variantGid) {
        payload.items = [
          {
            variantId: root.dataset.variantGid,
            quantity: selectedQty(),
          },
        ];
      }

      if (window.SKGPixels && typeof window.SKGPixels.track === "function") {
        window.SKGPixels.track(
          "InitiateCheckout",
          {
            value: (estimateTotals() || 0) / 100,
            currency: "MAD",
            content_ids: [root.dataset.productId || root.dataset.variantId || ""],
            content_name: productTitle(),
            content_type: "product",
            num_items: payload.selected_qty,
          },
          { eventId: "cod_ic_" + payload.idempotency_key },
        );
      }

      try {
        var res = await fetch(proxyBase + "/orders", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload),
        });
        var data = await res.json();
        if (!data.ok) {
          throw new Error(data.error || data.detail || "Échec de la commande");
        }

        var summary = {
          ts: Date.now(),
          order_name: data.order_name,
          public_token: data.public_token,
          totals: data.totals,
          name: payload.name,
          phone: payload.phone,
          city: payload.city,
          address: payload.address,
          product: productTitle(),
          // Lets the thank-you page itemise before the API round-trip returns.
          lines: computeBreakdown(pricingState()).lines,
        };
        localStorage.setItem("COD_LAST_ORDER", JSON.stringify(summary));

        // Keep overlay visible through navigation so the product page never flashes back.
        var thank = data.thank_you_path || root.dataset.thankyou || "/pages/thank-you";
        var sep = thank.indexOf("?") >= 0 ? "&" : "?";
        window.location.href = thank + sep + "o=" + encodeURIComponent(data.public_token);
      } catch (err) {
        console.error(err);
        hideConfirming();
        note.textContent = "❌ " + (err.message || "Problème d'envoi");
        btn.disabled = false;
        idempotencyKey = uuid();
        if (window.turnstile && turnstileWidgetId != null) {
          window.turnstile.reset(turnstileWidgetId);
          turnstileToken = "";
        }
      }
    });

    estimateTotals();
    mountTurnstile();
  }

  function boot() {
    document.querySelectorAll("[data-skg-cod]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
